import React from "react";
import { Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;

const VerticalItem = (props) => {
  const { content, centered, style } = props;

  return (
    <div className={centered ? "centered" : "vertical"}>
      <Text style={{ ...style, lineHeight: "16px" }}>{content}</Text>
    </div>
  );
};

export default VerticalItem;
